<template>
  <div>
    <v-app-bar dark color="secondary">
      <v-toolbar-title class="white--text">Devices</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn round @click="refreshPage">
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn rounded icon dark to="/devices/new">
        <v-icon>add</v-icon>
      </v-btn>
    </v-app-bar>
    <v-container>
      <v-card>
        <v-data-table
          dense
          :loading="loading"
          :headers="headers"
          :items="items"
          :sort-by="['lastUpdated']"
          :sort-desc="[false]"
          :items-per-page="-1"
          item-key="_id"
          must-sort
          class="elevation-1"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn small rounded icon class="mr-2" :to="'devices/' + item._id">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn
              small
              rounded
              icon
              class="mr-2"
              @click="deleteItem(item._id)"
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "DeviceList",
  data() {
    return {
      loading: true,
      headers: [
        { text: "Device", value: "name" },
        { text: "Code Name", value: "codename" },
        { text: "URL", value: "kosherUrl" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      items: [],
    };
  },
  methods: {
    getItems() {
      this.loading = true;
      axios.get(`https://api.safetelecom.net/api/devices`).then((response) => {
        this.items = response.data;
        this.loading = false;
      });
    },
    deleteItem(id) {
      confirm("Are you sure you want to delete this item?") &&
        axios
          .delete(`https://api.safetelecom.net/api/devices/${id}`)
          .then(() => {
            this.refreshPage();
          });
    },
    refreshPage() {
      this.items = [];
      this.getItems();
    },
  },
  created() {
    this.getItems();
  },
};
</script>
